module.exports = __webpack_public_path__ + "img/cross.17eb5bbe.svg";